import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import SubscriptionPage from '../Routes/SubscriptionPage';
import LoginPage from '../Routes/LoginPage';
import FailedPage from '../Routes/FailedPage';
import DeniedPage from '../Routes/DeniedPage';

const Routing = () => {
    const router=createBrowserRouter([
        {
            path:"/",
            element:<SubscriptionPage />
        },
        {
          path:"/login",
          element:<LoginPage />
        },
        {
          path:"/failed",
          element:<FailedPage />
        },
        {
          path:"/denied",
          element:<DeniedPage />
        },
        {
          path:"*",
          element:<Navigate to="/" />
        }
    ])
  return (
    <RouterProvider router={router} />
  )
}

export default Routing